import { NgModule } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { BrowserModule, Title } from "@angular/platform-browser";
import { MatSnackBarModule } from "@angular/material";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CheckboxModule } from "primeng/primeng";
import { CookieService } from "ngx-cookie-service";
import { ClipboardModule } from "ngx-clipboard";

import { MaterialAppModule } from "../ngmaterial.module";
import { ApiGatewayService } from "./api-gateway/api-gateway.service";
import { ApplicationImageComponent } from "./application-image/application-image.component";
import { BrowserTitleService } from "./browser-title/browser-title.service";
import { FooterComponent } from "./footer/footer.component";
import { AdminGuard, AuthenticateGuard } from "./guards";
import { HeaderComponent } from "./header/header.component";
import { HealthCheckService } from "./health-check/health-check.service";
import { TRANSLATION_PROVIDERS, TranslatePipe, TranslateService, TranslateComponent } from "./translate";
import { ValidationService } from "./validation/validation.service";
import { DeleteAccountConfirmationComponent } from "./header/delete-account/delete-account.component";
import { SnackbarService } from "./snackbar/snackbar.service";
import { MultiSelectComponent } from "./multi-select/multi-select.component";
import { FilterPipe } from "./filter-pipe/filter.pipe";
import { IconComponent } from "./icon/icon.component";
import { NavigationService } from "./navigation/navigation.service";
import { SpinnerOverlayComponent } from "./spinner/spinner-overlay.component";
import { SpinnerOverlayService } from "./spinner/spinner-overlay.service";
import { AccountInfoService } from "./account-info/account-info-service";
import { SafeHtmlPipe } from "./safehtml/safehtml";
import { ApiGatewayInterceptor } from "./api-gateway/api-gateway.interceptor";
import { SkipWizardService, SkipWizardComponent } from "./skip-wizard";
import { NameChangeComponent } from "./name-change";

@NgModule({
	imports: [
		HttpClientModule,
		BrowserModule,
		ClipboardModule,
		FormsModule,
		ReactiveFormsModule,
		CheckboxModule,
		MatSnackBarModule,
		MaterialAppModule,
		RouterModule
	],
	declarations: [
		ApplicationImageComponent,
		FooterComponent,
		HeaderComponent,
		TranslateComponent,
		TranslatePipe,
		DeleteAccountConfirmationComponent,
		MultiSelectComponent,
		FilterPipe,
		IconComponent,
		SpinnerOverlayComponent,
		SafeHtmlPipe,
		SkipWizardComponent,
		NameChangeComponent
	],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: ApiGatewayInterceptor, multi: true },
		ApiGatewayService,
		AuthenticateGuard,
		AdminGuard,
		BrowserTitleService,
		HealthCheckService,
		TRANSLATION_PROVIDERS,
		TranslateService,
		TranslatePipe,
		ValidationService,
		Title,
		SnackbarService,
		FilterPipe,
		CookieService,
		NavigationService,
		SpinnerOverlayService,
		AccountInfoService,
		SkipWizardService
	],
	entryComponents: [
		DeleteAccountConfirmationComponent,
		SpinnerOverlayComponent
	],
	exports: [
		ApplicationImageComponent,
		ClipboardModule,
		FooterComponent,
		HeaderComponent,
		TranslateComponent,
		TranslatePipe,
		MultiSelectComponent,
		FilterPipe,
		IconComponent,
		SpinnerOverlayComponent,
		SafeHtmlPipe,
		SkipWizardComponent,
		NameChangeComponent
	]
})
export class CommonModule { }
